import { render, staticRenderFns } from "./CalendarOptionsPicker.vue?vue&type=template&id=664d5670&scoped=true"
import script from "./CalendarOptionsPicker.vue?vue&type=script&lang=js"
export * from "./CalendarOptionsPicker.vue?vue&type=script&lang=js"
import style0 from "./CalendarOptionsPicker.vue?vue&type=style&index=0&id=664d5670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664d5670",
  null
  
)

export default component.exports